/**
 * BriqueChart의 Palette 기능 구현
 */

import { _ } from 'core-js'
import BriqueChart from './BriqueChart.vue'
// import { BRIQUE_PALETTES } from './Modal/BriqueChartModal.vue'
import template from './BriqueChartTemplate.json'

export default {
  /**
   * Palette 적용
   * @param {Object} element 차트 Element
   * @param {*} paletteName Palette Name
   * @param {*} isRelayout relayout 여부
   */
  applyPaletteToLayout (element, layout, paletteName, isRelayout = true) {
    // let palette = BRIQUE_PALETTES.find(item => { return item.name === paletteName })

    let oldColorway = layout.colorway
    // layout.colorway = palette.colorway
    // let colorwayLayout = { 'colorway': layout.colorway }

    if (isRelayout && !_.isEmpty(template[paletteName])) {
      // TODO: layout을 기존 값으로 초기화 하는 것이 필요할 것 같은데.. newPlot 말고 다른 방법이 없는지 확인 필요
      // BriqueChart.relayout(element, template[paletteName], true)
      BriqueChart.newPlot(element.id, element.briqueChartData.tracesOriginal, template[paletteName], element.briqueChartData.configOriginal, element.briqueChartOption)
    }

    if (isRelayout && !_.isEqual(layout.colorway, oldColorway)) {
      // BriqueChart.relayout(element, colorwayLayout, true)
    }

    // return colorwayLayout
  }
}
